// enums
export enum EMarketTypes {
  PRIMARY = "Primary",
  SECONDARY = "Secondary",
}

export enum EUserType {
  Employee = "Employee",
  Realtor = "Realtor",
  Client = "Client",
}

export enum EDealRequestType {
  Purchase = "Purchase",
  Sale = "Sale",
  DealService = "DealService",
  Other = "Other",
  Ransom = "Ransom",
  Estimate = "Estimate",
}

export enum EDealRequestStatus {
  Opened = "Opened",
  Active = "Active",
  Pending = "Pending",
  Cancelled = "Cancelled",
  Postponed = "Postponed",
  Closed = "Closed",
}

export enum EDealRequestSource {
  None = "None",
  TV = "TV",
  Radio = "Radio",
  ActivityOrPartnership = "ActivityOrPartnership",
  MediaOrNews = "MediaOrNews",
  OutdoorAd = "OutdoorAd",
  SearchServices = "SearchServices",
  MapAndGeoServices = "MapAndGeoServices",
  Recommendation = "Recommendation",
  Recollaboration = "Recollaboration",
  Website = "Website",
  TelegramBot = "TelegramBot",
}

// interfaces
export interface IMinifiedUserSchema {
  id: number;
  name?: string;
  firstName?: string;
  lastName?: string;
  patronymic?: string;
  type: EUserType;
  phone: string;
  photo?: string;
}
